import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=d36f280c&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"
import style0 from "./Question.vue?vue&type=style&index=0&id=d36f280c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36f280c",
  null
  
)

export default component.exports